import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const Testimonials = () => {
  return <section className="mb-10" data-id="element-293">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-294">
        Wat hondeneigenaren zeggen over deze nieuwe methode die vrij is van
        domineren, straffen en corrigeren
      </h2>
      <div className="space-y-6 mb-6" data-id="element-295">
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-296">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-297">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-298">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1uENzFyeTcPi87ozEBzC5A/Scherm%C2%ADafbeelding_2025-08-15_om_15.51.14.png" alt="Marieke uit Utrecht" className="w-16 h-16 rounded-full object-cover" data-id="element-299" />
            </div>
            <div data-id="element-300">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-301" />
              <p className="italic" data-id="element-302">
                "Na 20 minuten begreep ik al waarom onze wandelingen altijd
                chaotisch waren. Luna probeerde me de hele tijd te vertellen dat
                ze zich onveilig voelde, maar ik interpreteerde het als
                koppigheid. Het moment dat ik dat doorhad, veranderde alles."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-303">
                - Marieke uit Utrecht
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-304">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-305">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-306">
              <img src="https://images.unsplash.com/photo-1529429617124-95b109e86bb8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Thomas uit Antwerpen" className="w-16 h-16 rounded-full object-cover" data-id="element-307" />
            </div>
            <div data-id="element-308">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-309" />
              <p className="italic" data-id="element-310">
                "Mijn vrouw en ik keken elkaar halverwege het webinar aan.
                'Daarom doet hij dat!' zeiden we tegelijk. Plotseling maakten
                alle rare gewoontes van Rex perfect zin."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-311">
                - Thomas uit Antwerpen
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-312">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-313">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-314">
              <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Sandra uit Amsterdam" className="w-16 h-16 rounded-full object-cover" data-id="element-315" />
            </div>
            <div data-id="element-316">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-317" />
              <p className="italic" data-id="element-318">
                "Het was emotioneel. Ik realiseerde me dat Buddy mij al maanden
                probeerde iets te vertellen over zijn angst, en ik dacht maar
                dat hij ongehoorzaam was. Ik voelde me schuldig, maar ook
                opgelucht. Eindelijk begreep ik hem."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-319">
                - Sandra uit Amsterdam
              </p>
            </div>
          </div>
        </div>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-320">
        De verborgen schade van dominantie
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-321">
        Wat Marieke niet wist, was dat haar "alfaleider" benadering Luna
        eigenlijk schade aanbracht:
      </p>
      <ul className="mb-6 list-disc pl-5 space-y-2" data-id="element-322">
        <li data-id="element-323">
          <strong data-id="element-324">Chronische stress</strong> - Domineren zorgt voor constante
          stress bij honden. Constante stress is ongezond.
        </li>
        <li data-id="element-325">
          <strong data-id="element-326">Verhoogde reactiviteit</strong> - Honden raken prikkelbaar en
          reageren daarom sneller op een heftige manier
        </li>
        <li data-id="element-327">
          <strong data-id="element-328">Meer probleemgedrag</strong> - Gestresste honden blaffen meer,
          trekken meer, luisteren minder
        </li>
        <li data-id="element-329">
          <strong data-id="element-330">Gebroken vertrouwen</strong> - Je wordt een bron van
          onzekerheid in plaats van veiligheid
        </li>
      </ul>
      <p className="mb-6 leading-relaxed" data-id="element-331">
        27 recente studies ondersteunen Mech's latere inzichten. Honden zijn
        sociale leerders die bloeien onder duidelijke, liefdevolle communicatie
        en vertrouwen.
      </p>
      <p className="mb-6 leading-relaxed font-semibold text-blue-800" data-id="element-332">
        De waarheid: Honden hebben meer baat bij een begripvol baasje die hun
        taal spreekt, luistert en samenwerkt dan bij een dominante baas.
      </p>
    </section>;
};